import React from "react"
import FileKit from "@convertkit/file-kit"
import { useCurrentUser } from "hooks/use-current-user"
import { toast } from "@kit/design/toast"

export const FileUpload = React.forwardRef(({ editor, onComplete }, ref) => {
  const user = useCurrentUser()
  const handleFileChange = async event => {
    const file = event.target.files[0]

    const url = await uploadToFileKit(editor, file, user.account_id, toast)

    ref.current.value = null

    if (url) {
      onComplete({ name: file.name, url })
    }
  }

  return (
    <div style={{ display: "none" }}>
      <input
        ref={ref}
        id="file-upload"
        type="file"
        onChange={handleFileChange}
      />
    </div>
  )
})

const uploadToFileKit = async (editor, file, accountId, toast) => {
  const filekit = FileKit({
    authURL: "/filekit/sessions",
    filekitURL: process.env.FILEKIT_HOST,
    id: accountId
  })

  const result = await filekit.upload(file)

  if (result.errors && result.errors.length > 0) {
    toast({ type: "error", text: result.errors.join(", "), duration: 10000 })

    return
  }

  const url = result.download_url
  return url
}
